<template>
  <div class="sched-app-daily-entry" :class="{schedAppDailyEntryFull: isFull || allFull}">
    <img v-if="channel!='radio'" :src="data.series_img" class="sched-app-daily-entry-img" onerror="this.src = 'https://s3.amazonaws.com/3abn-sched-images/_blank.png'">
    <span class="sched-app-daily-entry-details" :class="{schedAppDailyEntryFull: isFull  || allFull}">
      <template v-if="channel=='radio'">
      <div class="sched-app-daily-entry-title" :class="channelColorCSS">{{ data.series_title }}</div>
      </template>
      <template v-else>
      <div class="sched-app-daily-entry-title" :class="channelColorCSS">{{ data.series_title }}</div>
      </template>
      <div class="sched-app-daily-entry-time">{{ formatTime(data.date) }}</div>
      <div class="sched-app-daily-entry-duration" v-if="data.duration">{{ formatDuration(data.duartion)  }}</div>
      <!-- TODO: Apply appropriate styling -->
      <div class="on-air" v-if="data.on_air"><a v-bind:href="channelToUrl(channel)" style="color: white; text-decoration-line: none;" target="_blank">On Air</a></div>

      <template v-if="(isFull || allFull) && channel!='radio'">
        <div><strong>Program Title:</strong> {{data.program_title}}</div>
        <div><strong>Program Code:</strong> {{data.program_code}}</div>
        <div><strong>Rating:</strong> {{data.rating}}</div>
        <div><strong>Description:</strong> {{data.description}}</div>
        <div v-if="data.speaker"><strong>Speaker:</strong> {{data.speaker}}</div>
        <div v-if="data.guest"><strong>Guest:</strong> {{data.guest}}</div>
        <div v-if="data.host"><strong>Host:</strong> {{data.host}}</div>
        <div v-if="data.music"><strong>Music:</strong> {{data.music}}</div>
        <div v-if="data.url"><a :href="data.url">Link</a></div>
        <div v-if="data.stream_url"><a :href="data.stream_url">Stream</a></div>
      </template>

      <template v-if="(isFull || allFull) && channel=='radio'">
        <div v-if="data.program_title"><strong>Program Title:</strong> {{data.program_title}}</div>
        <div><strong>Program Code:</strong> {{data.program_code}}</div>
        <div v-if="data.host"><strong>Host:</strong> {{data.host}}</div>
        <div v-if="data.guest"><strong>Guest:</strong> {{data.guest}}</div>
        <div v-if="data.stream_url"><a :href="data.stream_url">Stream</a></div>
      </template>

    </span>

    <template v-if="!isFull">
      <i class="material-icons" @click="toggleFull">
        expand_more
      </i>
    </template>
    <template v-if="isFull">
      <i class="material-icons" @click="toggleFull">
        expand_less
      </i>
    </template>

  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: ['data', 'allFull', 'channel'],

  data () {
    return {
      isFull: false
    }
  },

  computed: {
    channelColorCSS () {
      return `sched-app-${this.$store.state.channel.value}-color`
    }
  },

  methods: {
    formatTime (d) {
      return moment(d).tz(this.$store.state.timezone).format('hh:mm A')
    },
    channelToUrl (channel) {
      switch (channel) {
        case 'main':
          return 'https://3abnplus.tv/programs/live-pxsqo62adkg'
        case 'proc':
          return 'https://3abnplus.tv/programs/live-wdte__35mhy?categoryId=48342'
        case 'dare':
          return 'https://3abnplus.tv/programs/live-8wb9jmtfobo?categoryId=48342'
        case 'int':
          return 'https://3abnplus.tv/programs/live-d6m99by540u?categoryId=48342'
        case 'canada':
          return 'https://3abnplus.tv/programs/live-xvpmsd89rti?category_id=48342'
        case 'kids':
          return 'https://3abnplus.tv/programs/live-hn7y4npjbem'
        case 'lat':
          return 'https://3abnplus.tv/programs/live-ya80hrvnrp0'
        case 'praise':
          return 'https://3abnplus.tv/programs/live-mlg0wjspb3i?categoryId=48342'
        case 'radio':
          return 'https://3abnplus.tv/programs/live-1d5jqrwicew?categoryId=42373'
      }
    },

    formatDuration (d) {
      d = d.split(':')
      const hours = parseInt(d[0])
      let minutes = parseInt(d[1])

      if (minutes >= 13 && minutes <= 15) {
        minutes = 15
      }

      if (minutes >= 25 && minutes <= 30) {
        minutes = 30
      }

      if (minutes >= 53 && minutes <= 60) {
        minutes = 60
      }

      return `${(hours * 60) + minutes}m`
    },

    toggleFull () {
      this.isFull = !this.isFull
    }

  },
  updated () {
    if (this.data.on_air) {
      this.$el.scrollIntoView()
    }
  },
  mounted () {
    if (this.data.on_air) {
      this.$el.scrollIntoView()
    }
  }
}
</script>
<!-- -->
<style>
.sched-app-daily-entry {
    background: #FFF;
    height: 100px;
    display: flex;
    margin-bottom: 14px;
}

.sched-app-daily-entry-details {
  height: 100px;
  padding-left: 20px;
  flex: 1 1 auto;
}

.schedAppDailyEntryFull {
  height: auto;
  padding-bottom: 6px;
}

.sched-app-daily-entry-title {
  font-family: 'Open Sans Condensed', sans-serif;
  font-weight: 700;
  color: #008dcb;
  font-size: 24px;
}

.sched-app-daily-entry-time {
  color: #444;
  font-size: 20px;
}

.sched-app-daily-entry-duration {
  color: #777;
}

.material-icons {
  color: #888;
  flex: 0 0 30px;
  user-select: none;
  cursor: pointer;
}

.sched-app-daily-entry-img {
    height: 100px;
    width: 175px;
   background:#fff;
}

.on-air{
  height: 25px;
  width: 60px;
  padding-left: 10px;
  font-weight: 1000;
  background: red;
}

</style>
